import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeResourceUrl',
  standalone: true,
})
export class SafeResourceUrlPipe implements PipeTransform {
  private readonly html = inject(DomSanitizer);

  public transform(url: string): SafeResourceUrl {
    return this.html.bypassSecurityTrustResourceUrl(url);
  }
}
